export default __webpack_public_path__ + "static/media/crif.278732d4.svg";